import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { InnerBlocks, RichText, useBlockProps } from '@wordpress/block-editor';
export default function save(_ref) {
  let {
    attributes
  } = _ref;
  return createElement("li", useBlockProps.save(), createElement(RichText.Content, {
    value: attributes.content
  }), createElement(InnerBlocks.Content, null));
}
//# sourceMappingURL=save.js.map